import React, { useState } from 'react';
import IconButton from '~ComponentsImproved/IconButton';
import KDSIcon from '~Assets/icons/product_kitchen-display.svg';
import Icon from '~ComponentsImproved/Icon';
import Modal from '~ComponentsImproved/Modal';
import styled from '@emotion/styled';
import EventedKitchenDisplay from '~Scenes/EventedKitchenDisplay';
import { useLicenses, useSelector } from '~Hooks';

const KDSWrapper = styled.div`
  height: 90%;
  max-width: 80vw;
`;

const KDSButtonModal = () => {
  const licenses = useLicenses();
  const venueId = useSelector((state) => state.venueId);
  const [showingKDSModal, setShowingKDSModal] = useState(false);

  if (!licenses.hasKDS) {
    return null;
  }

  return (
    <>
      <IconButton
        text="KDS"
        textColor="var(--colorWhite)"
        onClick={() => setShowingKDSModal(true)}
        icon={<Icon src={KDSIcon} color="var(--colorWhite)" />}
      />

      <Modal
        isShowing={showingKDSModal}
        hide={() => setShowingKDSModal(false)}
        position="flex-start">
        <KDSWrapper>
          {venueId && <EventedKitchenDisplay venueId={venueId} isModal={true} />}
        </KDSWrapper>
      </Modal>
    </>
  );
};

export default KDSButtonModal;
